// extracted by mini-css-extract-plugin
module.exports = {"root":"PresentationList_root__elKmq","title_text":"PresentationList_title_text__3M_8X"};